module.exports = {
          srcSet: __webpack_public_path__ + "9b45d95675e776505021c17f4167a52a-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "9b45d95675e776505021c17f4167a52a-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "9b45d95675e776505021c17f4167a52a-60.png",
          toString:function(){return __webpack_public_path__ + "9b45d95675e776505021c17f4167a52a-60.png"},
          
          width: 60,
          height: 60
        }